// extracted by mini-css-extract-plugin
export default {"illustration":"Illustration_illustration__R1bUM"};